import React, { useState, useEffect } from 'react'
import styled from "styled-components";
import NftBanner from "@/components/NftBanner/index";
import { useNavigate, Outlet } from "react-router-dom";
import { useContractRead } from 'wagmi'
import { NFTCA, nftAbi } from '@/utils/abi'


const CountdownButton = ({ seconds, cb }) => {
  const [timeLeft, setTimeLeft] = useState(seconds);

  
  useEffect(() => {
    if (timeLeft === 0) {
      return cb();
    }
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);


  const formatTime = (time) => {
    const addZero = (num) => (num < 10 ? `0${num}` : num);
    const hours = addZero(Math.floor(time / 3600));
    const minutes = addZero(Math.floor((time % 3600) / 60));
    const seconds = addZero(time % 60);
    return `${hours}:${minutes}:${seconds}`;
  };

  return (
    <ButtonText>{formatTime(timeLeft)}</ButtonText>
  );
};



const ButtonText = styled.div`
  font-weight: 600;
  font-size: 120px;
  line-height: 172px;
  color: #fff;  
  width: 675px;
`;

export default function Mint() {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(0)
  const [show, setIsShow] = useState(false)
  
  useEffect(() => {

    var future = new Date(1682427600000);
    
    var now = new Date();
    var timeDiff = future - now.getTime();
    if(timeDiff < 0){
      setSeconds(0)
      setIsShow(true)
    }else{      
      setSeconds(Math.floor(timeDiff / 1000))
      setIsShow(true)
    }
  }, [])
    
  
  const cb = ()=>{
    navigate('/mint');
  }

  let { data:phaInfo } = useContractRead({
    address: NFTCA,
    abi: nftAbi,
    functionName: 'currentPhrase',
  })

  
  return (
    <MintWrapper>
      <div className='main-top'>
        <NftBanner/>
        <div className='main-desc'>
          <div className='desc-title-1'>Jungle Squad   </div>
          <div className='desc-title-2'>Mint Time - Phase {3} </div>
          {
            show && <CountdownButton seconds={seconds} cb={cb}/>
          }          
        </div>
      </div>
    </MintWrapper>
  )
}
const MintWrapper = styled.div`
  display: flex;
  justify-content: center;
  min-width: 1260px;
  margin-top: 95px;
  .main-top{
    display: flex;
  }
  .main-desc{
    padding-left: 3.5vw;
    .desc-title-1{
      font-weight: 600;
      font-size: 60px;
      line-height: 86px;
      color: #32DE86;
      padding-top: 30px;
      padding-bottom: 27px;
    }
    .desc-title-2{
      font-weight: 400;
      font-size: 30px;
      line-height: 43px;      
      background: linear-gradient(92.76deg, #2DFF28 1.45%, #32E6FF 36.69%, #FFE923 60.49%, #44FFBC 85.2%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;    
      padding-bottom :30px;
    }
  }
  
`
